export default __webpack_public_path__ + "static/media/7.3.a284022b.webm";